export default __webpack_public_path__ + "static/media/bbbb.9e5c7eef.jpg";